// extracted by mini-css-extract-plugin
module.exports = {"jobWidth":"196px","unit":"var(--ring-unit)","tile":"PipelineStructureJob__tile--Y2","icon":"PipelineStructureJob__icon--Tn","name":"PipelineStructureJob__name--Vw"};